module.exports = __webpack_public_path__ + "static/media/muy-buena-hover.2d4ef320.svg";